import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { MatSnackBar } from '@angular/material/snack-bar';
import { endPoints } from '../../constants/endpoints';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private hubConnection!: signalR.HubConnection;
  isNotificationPanelOpen: boolean = false;
  constructor(public snackBar: MatSnackBar) {}

  public startConnection = (callback: () => void) => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(endPoints.casemgmt.Notify.URI, {
        //.withUrl('wss://digitalapi.ups.com:7058/api/scscmplatform/v1/notifications/event',{
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
        withCredentials: true,
      })
      .withAutomaticReconnect()
      .build();

    this.hubConnection.onreconnected(() => {
      console.log('Reconnection started');
      this.registerNotificationListener(callback);
    });

    this.hubConnection
      .start()
      .then(() => {
        console.log('Connection started');
        this.registerNotificationListener(callback);
      })
      .catch((err) => console.log('Error while starting connection: ' + err));
  };

  private registerNotificationListener = (callback: () => void) => {
    this.hubConnection.on(
      'ReceiveNotification',
      (notification: Notification) => {
        callback();
        console.log('notification // ', notification);
        return true;
      },
    );
  };

  public stopConnection = () => {
    if (this.hubConnection) {
      this.hubConnection.stop().then(() => {
        console.log('SignalR connection stopped');
      });
    }
  };
}

export class Notification {
  public productID!: string;
  public productName!: string;
  public message!: string;
}
